export const CloseIcon = () => {
    return (
        <>
            <title>Close Window</title>
            <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
        </>
    );
};
